import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

import DatepickerField from 'components/fields/DatepickerField';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import dateFormat from 'config/dateFormat';

import sortInsurance from 'utils/sortInsurance';

class OrdersTableRowItemReimbsDate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focusValue: null,
    };

    this.onFieldFocus = this.onFieldFocus.bind(this);
  }

  onFieldFocus(event) {
    this.setState({
      focusValue: {
        [event.target.name]: event.target.value,
      },
    });
  }

  render() {
    const {
      namePrefix,
      disabled,
      onBlur,
      Insurance,
      className,
    } = this.props;
    const { focusValue } = this.state;
    if (!Insurance || Insurance.length === 0) {
      return (
        <Field
          className={className}
          id={`${namePrefix}.Reimbs Date`}
          name={`${namePrefix}.Reimbs Date`}
          component={DatepickerField}
          validate={[validate.date]}
          normalize={normalize.date}
          disabled={disabled}
          onInputBlur={(event, newValue) => {
            const values = {};
            values[namePrefix] = {
              'Reimbs Date': newValue || event.target.value,
            };
            onBlur(values);
          }}
          onDateSelect={(event, newValue) => {
            const values = {};
            values[namePrefix] = {
              'Reimbs Date': newValue,
            };
            onBlur(values);
          }}
          minDate="01/01/1900"
          maxDate="01/01/2100"
          dateFormat={dateFormat}
          placeholder="mm/dd/yyyy"
          maxLength="10"
          size="sm"
          color="light"
          errorPlacement="left"
          fullWidth
          endIcon="start"
        />
      );
    }
    return (
      <div>
        {sortInsurance(Insurance).map(insurance => (
          <Field
            key={insurance.ID}
            className={className}
            id={`${namePrefix}.orderLineInsuranceParam.insuranceID-${insurance.ID}.Reimbs Date`}
            name={`${namePrefix}.orderLineInsuranceParam.insuranceID-${insurance.ID}.Reimbs Date`}
            component={DatepickerField}
            validate={[validate.date]}
            normalize={normalize.date}
            disabled={disabled}
            onFocus={this.onFieldFocus}
            onInputBlur={(event, newValue) => {
              if (focusValue
                && focusValue[`${namePrefix}.orderLineInsuranceParam.insuranceID-${insurance.ID}.Reimbs Date`] !== undefined
                && ((newValue && focusValue[`${namePrefix}.orderLineInsuranceParam.insuranceID-${insurance.ID}.Reimbs Date`] !== newValue)
                  || focusValue[`${namePrefix}.orderLineInsuranceParam.insuranceID-${insurance.ID}.Reimbs Date`] !== event.target.value)) {
                const values = {
                  [namePrefix]: {
                    orderLineInsuranceParam: {},
                  },
                };
                values[namePrefix].orderLineInsuranceParam[`insuranceID-${insurance.ID}`] = {
                  'Reimbs Date': newValue || event.target.value,
                };
                this.setState({ focusValue: null });
                onBlur(values);
              }
            }}
            onDateSelect={(event, newValue) => {
              if (focusValue
                && focusValue[`${namePrefix}.orderLineInsuranceParam.insuranceID-${insurance.ID}.Reimbs Date`] !== undefined
                && focusValue[`${namePrefix}.orderLineInsuranceParam.insuranceID-${insurance.ID}.Reimbs Date`] !== newValue) {
                const values = {
                  [namePrefix]: {
                    orderLineInsuranceParam: {},
                  },
                };
                values[namePrefix].orderLineInsuranceParam[`insuranceID-${insurance.ID}`] = {
                  'Reimbs Date': newValue,
                };
                onBlur(values);
              }
              this.setState({ focusValue: null });
            }}
            minDate="01/01/1900"
            maxDate="01/01/2100"
            dateFormat={dateFormat}
            placeholder="mm/dd/yyyy"
            maxLength="10"
            size="sm"
            color="light"
            errorPlacement="left"
            fullWidth
            endIcon="start"
          />
        ))}
      </div>
    );
  }
}

OrdersTableRowItemReimbsDate.propTypes = {
  namePrefix: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onBlur: PropTypes.func,
  Insurance: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })),
};

OrdersTableRowItemReimbsDate.defaultProps = {
  className: '',
  onBlur: () => {},
  Insurance: [],
  disabled: false,
};

export default OrdersTableRowItemReimbsDate;



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableRowItemReimbsDate.js